import { Injectable } from '@angular/core';
import { EspecieAlmoxarifado, Sistemas } from '../../public-api';
import {
  ComissaoMembroAtribuicao, ComissaoMembroNaturezaCargo, ConservacaoPatrimonio, CriterioDesempatePregao, CriterioJulgamento, CriterioJulgamentoValor, FavorecidoEnquadramento,
  FormatoLicitacao, PrioridadeRCMS, SituacaoLicitacao, SituacaoPatrimonio, SituacaoProponente, SituacaoProposta, TipoComissao, TipoContato,
  TipoContrato, TipoFavorecido, TipoObjetoLicitacao, TipoPregao
} from '../components/types';
import { Login } from '../entidade/login/login';
import { StatusRequisicao } from '../entidade/requisicao/status-requisicao.enum';

declare function atualizarMascarasData(): any;
declare function convertEnterParaTab(): any;

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  private static SESSIONSTORAGE_NAME = 'login_pmsjrp-transparencia_38';

  // padrao de url para transparencia .../pagina/data1/data2 ou .../pagina/data1/data2/filtro
  public static TRANSPARENCIA_REGEXP: RegExp = /trasparencia\/(.*)\/(\d+)\/\d{4}\-\d{2}\-\d{2}\/\d{4}\-\d{2}\-\d{2}(.*)|(.*)\/(\d+)\/([1-12])\/(\d+)\/\w+(.*)/;

  public static obterSessaoLogin(): Login {
    return JSON.parse(sessionStorage.getItem(GlobalService.SESSIONSTORAGE_NAME));
  }

  public static salvarSessaoLogin(login: Login): void {
    sessionStorage.setItem(GlobalService.SESSIONSTORAGE_NAME, JSON.stringify(login));
  }

  public static limparSessaoLogin(limparTodas?: boolean): void {
    sessionStorage.setItem(GlobalService.SESSIONSTORAGE_NAME, null);
    if (limparTodas) sessionStorage.clear();
  }

  public calendarMascara() {
    atualizarMascarasData();
  }

  public convertEnterParaTab() {
    convertEnterParaTab();
  }

  public obterMes(mes: number, abreviado?: boolean): string {
    switch (mes) {
      case 1: {
        return abreviado ? 'JAN' : 'JANEIRO';
      }
      case 2: {
        return abreviado ? 'FEV' : 'FEVEREIRO';
      }
      case 3: {
        return abreviado ? 'MAR' : 'MARÇO';
      }
      case 4: {
        return abreviado ? 'ABR' : 'ABRIL';
      }
      case 5: {
        return abreviado ? 'MAI' : 'MAIO';
      }
      case 6: {
        return abreviado ? 'JUN' : 'JUNHO';
      }
      case 7: {
        return abreviado ? 'JUL' : 'JULHO';
      }
      case 8: {
        return abreviado ? 'AGO' : 'AGOSTO';
      }
      case 9: {
        return abreviado ? 'SET' : 'SETEMBRO';
      }
      case 10: {
        return abreviado ? 'OUT' : 'OUTUBRO';
      }
      case 11: {
        return abreviado ? 'NOV' : 'NOVEMBRO';
      }
      case 12: {
        return abreviado ? 'DEZ' : 'DEZEMBRO';
      }
      case 0:
        return abreviado ? 'ABE' : 'ABERTURA';
      case 13:
        return abreviado ? 'FEC PAR' : 'FECHAMENTO PARCIAL';
      case 14:
        return abreviado ? 'FEC BAL' : 'FECHAMENTO BALANÇO';
      default: {
        return String(mes);
      }
    }
  }

  public obterListaMeses() {
    return [
      { id: '1', nome: 'JANEIRO' },
      { id: '2', nome: 'FEVEREIRO' },
      { id: '3', nome: 'MARÇO' },
      { id: '4', nome: 'ABRIL' },
      { id: '5', nome: 'MAIO' },
      { id: '6', nome: 'JUNHO' },
      { id: '7', nome: 'JULHO' },
      { id: '8', nome: 'AGOSTO' },
      { id: '9', nome: 'SETEMBRO' },
      { id: '10', nome: 'OUTUBRO' },
      { id: '11', nome: 'NOVEMBRO' },
      { id: '12', nome: 'DEZEMBRO' }
    ];
  }

  public obterDataBR() {
    // atualizarMascarasData();
    const ptBR = {
      firstDayOfWeek: 0,
      dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
      monthNames: [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      today: 'Hoje',
      clear: 'Limpar'
    };

    return ptBR;
  }

  public obterAvaliacoes() {
    return [
      { id: '1', nome: 'EMPENHOS' },
      { id: '2', nome: 'CONTRATOS' },
      { id: '3', nome: 'LICITAÇÕES' },
      { id: '4', nome: 'PATRIMÔNIO' },
      { id: '5', nome: 'ADIANTAMENTOS' },
      { id: '20', nome: 'AUDIÊNCIA PÚBLICA' },
      { id: '21', nome: 'LEI DE DIRETRIZES ORÇAMENTÁRIAS' },
      { id: '22', nome: 'ANEXO DE METAS FISCAIS' },
      { id: '23', nome: 'DISPONIBILIZAÇÃO DOS ESTUDOS E ESTIMATIVAS DA RECEITA' },
      { id: '24', nome: 'CRONOGRAMA MENSAL DE DESEMBOLSOS' },
      { id: '25', nome: 'METAS BIMESTRAIS DE ARRECADAÇÃO' },
      { id: '26', nome: 'ANEXO DE RISCOS FISCAIS' },
      { id: '27', nome: 'LIMITAÇÃO DE EMPENHO E MOVIMENTAÇÃO FINANCEIRA' },
      { id: '28', nome: 'OPERAÇÕES DE CRÉDITO' },
      { id: '29', nome: 'DÍVIDA CONSOLIDADA LÍQUIDA' },
      { id: '30', nome: 'APLICAÇÃO DA RECEITA DE ALIENAÇÃO DE BENS' },
      { id: '31', nome: 'CONSOLIDAÇÃO DAS CONTAS' },
      { id: '32', nome: 'UTILIZAÇÃO DOS RECURSOS VINCULADOS' },
      { id: '33', nome: 'IDENTIFICAÇÃO DE BENEFICIÁRIOS DE PAGAMENTOS DE SENTENÇAS JUDICIAIS' },
      { id: '34', nome: 'RENÚNICA DE RECEITA' },
      { id: '35', nome: 'PUBLICAÇÃO DO RELATÓRIO RESUMIDO DA EXECUÇÃO ORÇAMENTÁRIA – RREO' },
      { id: '36', nome: 'PUBLICAÇÃO DO RELATÓRIO DE GESTÃO FISCAL – RGF' },
      { id: '37', nome: 'DESPESAS COM PESSOAL' },
      { id: '38', nome: 'INSTITUIÇÃO, PREVISÃO E EFETIVA ARRECADAÇÃO DE TRIBUTOS' }
    ];
  }

  public obterSituacao(idx: string) {
    switch (idx) {
      case '1':
        return 'AGUARDANDO';
      case '2':
        return 'ANDAMENTO';
      case '3':
        return 'FINALIZADO';
      case '4':
        return 'CANCELADO';
      case '99':
        return 'CANCELADO';
      default:
        return '-';
    }
  }

  public obterTipo(idx: number) {
    switch (idx) {
      case 1:
        return 'ADIANTAMENTO';
      case 2:
        return 'CONTRATO';
      case 3:
        return 'LICITAÇÃO';
      case 4:
        return 'PATRIMÔNIO';
      case 5:
        return 'PROTOCOLO';
      case 99:
        return 'OUTROS';
      default:
        return '-';
    }
  }

  public obterEspecie(idx: string) {
    switch (idx) {
      case 'AB1':
        return 'ABERTURA DE EXERCÍCIO CONTA BANCÁRIA - AB1';
      case 'AB2':
        return 'ABERTURA DE EXERCÍCIO FICHAS EXTRA ORÇAMENTÁRIAS - AB2';
      case 'ALG':
        return 'ALIENAÇÃO DE BENS - GANHO - ALG';
      case 'ALP':
        return 'ALIENAÇÃO DE BENS - PERDA - ALP';
      case 'EOA':
        return 'ANULAÇÃO DE EMPENHOS ORÇAMENTÁRIOS - EOA';
      case 'PGA':
        return 'ANULAÇÃO DE PAGAMENTOS ORÇAMENTÁRIOS - PGA';
      case 'ADI':
        return 'ADIANTAMENTOS CONCEDIDOS - ADI';
      case 'ADD':
        return 'ADIANTAMENTOS DEVOLVIDOS - ADD';
      case 'AAD':
        return 'ADIANTAMENTOS APROPRIAÇÃO DE DESPESA - AAD';
      case 'ADU':
        return 'ADIANTAMENTOS UTILIZADOS - ADU';
      case 'RPE':
        return 'APLICAÇÃO EDUCAÇÃO - RPE';
      case 'ADA':
        return 'ARRECADAÇÃO DIVIDA ATIVA TRIBUTARIAS - CONCOMITANTE - ADA';
      case 'ADN':
        return 'ARRECADAÇÃO DIVIDA ATIVA NAO TRIBUTARIAS - CONCOMITANTE - ADN';
      case 'AAC':
        return 'ASSINATURA ADITAMENTO AUXÍLIO-CONCESSÃO - AAC';
      case 'ACC':
        return 'ASSINATURA AUXÍLIO, SUBVENÇÃO E CONTRIBUIÇÃO CONCESSÃO - ACC';
      case 'ASC':
        return 'ASSINATURA AUXÍLIO-CONCESSÃO - ASC';
      case 'CTA':
        return 'BAIXA CONTRATOS DE ALUGUÉIS - CTA';
      case 'CTE':
        return 'BAIXA CONTRATOS DE EMPRESTIMOS CONCEDIDOS - CTE';
      case 'CAO':
        return 'ASSINATURA CONTRATOS OUTROS - CAO';
      case 'CAA':
        return 'ASSINATURA CONTRATOS DE ALUGUEL - CAA';
      case 'CAB':
        return 'ASSINATURA CONTRATOS DE FORNECIMENTO DE BENS - CAB';
      case 'CAG':
        return 'ASSINATURA CONTRATOS DE GESTÃO - CAG';
      case 'CTB':
        return 'BAIXA CONTRATOS DE FORNECIMENTO DE BENS - CTB';
      case 'CAG':
        return 'ASSINATURA CONTRATOS DE GESTÃO - CAG';
      case 'CAS':
        return 'ASSINATURA CONTRATOS DE FORNECIMENTO DE SERVIÇO - CAS';
      case 'CAE':
        return 'ASSINATURA CONTRATOS DE EMPRESTIMOS CONCEDIDOS - CAE';
      case 'CAM':
        return 'ASSINATURA CONTRATOS DE SERVIÇOS E MATERIAIS - CAM';
      case 'CAP':
        return 'ASSINATURA CONTRATOS DE PARCELAMENTO - CAP';
      case 'CTS':
        return 'BAIXA CONTRATOS DE FORNECIMENTO DE SERVIÇOS - CTS';
      case 'CTP':
        return 'BAIXA CONTRATOS DE PARCELAMENTOS - CTP';
      case 'CSS':
        return 'BAIXA CONTRATOS DE SEGUROS - CSS';
      case 'COS':
        return 'RETENÇÕES EXTRA ORÇAMENTÁRIA - CONCOMITANTE - COS';
      case 'COV':
        return 'BAIXA CONVENIOS AUXILIOS E SUBVENCOES - COV';
      case 'LCT':
        return 'BAIXA TERMO DE COLABORAÇÃO - LCT';
      case 'LTF':
        return 'BAIXA TERMO DE FOMENTO - LTF';
      case 'LCO':
        return 'BAIXA ACORDO DE COOPERAÇÃO - LCO';
      case 'CR1':
        return 'CRÉDITO ADICIONAL SUPLEMENTAR - CR1';
      case 'CR2':
        return 'CRÉDITO ADICIONAL EXCESSO DE ARRECADAÇÃO - CR2';
      case 'CR3':
        return 'CRÉDITO ADICIONAL SUPERÁVIT FINANCEIRO - CR3';
      case 'CR4':
        return 'CRÉDITO ADICIONAL OPERAÇÕES DE CRÉDITO - CR4';
      case 'CR5':
        return 'CRÉDITO ADICIONAL RESERVA DE CONTINGÊNCIA - CR5';
      case 'CR6':
        return 'CRÉDITO ADICIONAL PARAGRAFO 8˚ DO ARTIGO 166 - CR6';
      case 'CR7':
        return 'CRÉDITO ESPECIAL REMANEJAMENTO - CR7';
      case 'CR8':
        return 'CRÉDITO ESPECIAL SUPLEMENTAR - CR8';
      case 'CR9':
        return 'CRÉDITO ESPECIAL EXCESSO DE ARRECADAÇÃO - CR9';
      case 'CR10':
        return 'CRÉDITO ESPECIAL SUPERÁVIT FINANCEIRO - CR10';
      case 'CR11':
        return 'CRÉDITO ESPECIAL OPERAÇÕES DE CRÉDITO - CR11';
      case 'CR12':
        return 'CRÉDITO ESPECIAL RESERVA DE CONTINGÊNCIA - CR12';
      case 'CR13':
        return 'CRÉDITO ESPECIAL PARAGRAFO 8˚ DO ARTIGO 166 - CR13';
      case 'CR14':
        return 'CRÉDITO ESPECIAL REMANEJAMENTO - CR14';
      case 'CR15':
        return 'CRÉDITO EXTRAORDINÁRIO SUPLEMENTAR - CR15';
      case 'CR16':
        return 'CRÉDITO EXTRAORDINÁRIO EXCESSO DE ARRECADAÇÃO - CR16';
      case 'CR17':
        return 'CRÉDITO EXTRAORDINÁRIO SUPERÁVIT FINANCEIRO - CR17';
      case 'CR18':
        return 'CRÉDITO EXTRAORDINÁRIO OPERAÇÕES DE CRÉDITO - CR18';
      case 'CR19':
        return 'CRÉDITO EXTRAORDINÁRIO RESERVA DE CONTINGÊNCIA - CR19';
      case 'CR20':
        return 'CRÉDITO EXTRAORDINÁRIO PARAGRAFO 8˚ DO ARTIGO 166 - CR20';
      case 'CR21':
        return 'CRÉDITO EXTRAORDINÁRIO REMANEJAMENTO - CR21';
      case 'CR90':
        return 'CRÉDITOS ADICIONAIS SUPLEMENTAR CANCELAMENTO DOTAÇÃO - CR90';
      case 'CR91':
        return 'CRÉDITOS ADICIONAIS ESPECIAL CANCELAMENTO DOTAÇÃO - CR91';
      case 'DDC':
        return 'DEVOLUÇÃO DEPÓSITOS E CAUÇÕES - DDC';
      case 'DRP':
        return 'DEVOLUÇÃO DE RECURSOS PREFEITURA - DRP';
      case 'DRC':
        return 'DEVOLUÇÃO DE RECURSOS CAMARA - DRC';
      case 'ELO':
        return 'EM LIQUIDAÇÃO ORÇAMENTÁRIA - ELO';
      case 'ELR':
        return 'EM LIQUIDAÇÃO RESTOS - ELR';
      case 'EMP':
        return 'EMPENHOS COM PRÉ-EMPENHO - EMP';
      case 'EPA':
        return 'EMPENHOS COM PRÉ-EMPENHO - ANULAÇÃO - EPA';
      case 'EMO':
        return 'EMPENHOS ORÇAMENTÁRIOS - EMO';
      case 'EOA':
        return 'ANULAÇÃO EMPENHOS ORÇAMENTÁRIOS - EOA';
      case 'EMD':
        return 'EMPENHOS ORÇAMENTÁRIOS DISPONIBILIDADE EXERCÍCIO ANTERIOR - EMD';
      case 'EMA':
        return 'ANULAÇÃO EMPENHOS ORÇAMENTÁRIOS DISPONIBILIDADE EXERCÍCIO ANTERIOR - EMA';
      case 'ESP':
        return 'EMPENHOS REFORÇO - SEM PRÉ-EMPENHO - ESP';
      case 'ECP':
        return 'EMPENHOS REFORÇO - COM PRÉ-EMPENHO - ECP';
      case 'ERD':
        return 'EMPENHOS RESERVA DE DOTAÇÃO - ERD';
      case 'CRA':
        return 'EXCESSO DE ARRECADAÇÃO - ANULAÇÃO - CRA';
      case 'FOD':
        return 'FIXAÇÃO ORÇAMENTARIA DA DESPESA - FOD';
      case 'INC':
        return 'INCORPORAÇÃO DE OBRAS E INSTALAÇÕES - INC';
      case 'LEO':
        return 'LIQUIDAÇÃO ORÇAMENTÁRIA - LEO';
      case 'LEA':
        return 'ANULAÇÃO LIQUIDAÇÃO ORÇAMENTÁRIA - LEO';
      case 'PLO':
        return 'LIQUIDAÇÃO DE PRÉ LIQUIDAÇÃO - PLO';
      case 'PLR':
        return 'LIQUIDAÇÃO DE PRÉ LIQUIDAÇÃO DE RESTO - PLR';
      case 'LRP':
        return 'LIQUIDAÇÃO DE RESTOS A PAGAR - PROCESSADOS - LRP';
      case 'LRN':
        return 'LIQUIDAÇÃO DE RESTOS A PAGAR - NÃO PROCESSADOS - LRN';
      case 'CAO':
        return 'CONTRATO ASSINATURA OUTRO TERCEIRO - CAO';
      case 'CTO':
        return 'BAIXA CONTRATOS OUTROS - CTO';
      case 'COR':
        return 'OUTROS CONVENIOS RECEBIDOS - REMUNERAÇÃO DE APLICAÇÃO - COR';
      case 'SAR':
        return 'OUTROS AUXILIOS, SUBVENÇÕES, CONTRIBUIÇÕES RECEBIDOS - REMUNERAÇÃO - SAR';
      case 'COC':
        return 'BAIXA OUTROS CONVÊNIOS CONCEDIDOS - COC';
      case 'OCC':
        return 'OUTROS CONVÊNIOS CONCEDIDOS ASS. C - OCC';
      case 'OCR':
        return 'OUTROS CONVÊNIOS RECEBIDO ASS. C - OCR';
      case 'PGO':
        return 'PAGAMENTOS ORÇAMENTÁRIOS - PGO';
      case 'PGE':
        return 'PAGAMENTOS EXTRA ORÇAMENTÁRIOS - PGE';
      case 'BRE':
        return 'BAIXA RETENÇÕES EXTRA ORÇAMENTÁRIAS - BRE';
      case 'BCE':
        return 'BAIXA CONSIGNAÇÕES - BCE';
      case 'TDE':
        return 'PAGAMENTOS EXTRA ORÇAMENTÁRIOS SEM ORIGEM TRANSF DISP. EXTRA - TDE';
      case 'PGR':
        return 'PAGAMENTOS DE RESTOS A PAGAR - PGR';
      case 'PRN':
        return 'PAGAMENTO DE RESTOS A PAGAR NÃO PROCESSADOS - CONCOMITANTE - PRN';
      case 'PRP':
        return 'PAGAMENTO DE RESTOS A PAGAR PROCESSADOS  - CONCOMITANTE - PRP';
      case 'PDL':
        return 'PARCELAMENTO DE DIVIDA - BAIXA - PDL';
      case 'PAD':
        return 'PREVISÃO ADICIONAL DA DESPESA - PAD';
      case 'PED':
        return 'PREVISÃO REDUTORA DA DESPESA - PED';
      case 'PAR':
        return 'PREVISÃO ADICIONAL DA RECEITA - PAR';
      case 'PIR':
        return 'PREVISÃO INICIAL DA RECEITA - PIR';
      case 'PRR':
        return 'PREVISÃO INICIAL REDUTORES DA RECEITA - PRR';
      case 'RRP':
        return 'PREVISÃO INICIAL RENUNCIA DE RECEITA - RRP';
      case 'PRS':
        return 'PREVISÃO INICIAL RESTITUIÇÃO DE RECEITA - PRS';
      case 'PTC':
        return 'PREVISÃO TRANSFERENCIAS A CONCEDER - PTC';
      case 'PTR':
        return 'PREVISÃO TRANSFERENCIAS A RECEBER - PTR';
      case 'PCA':
        return 'PREVISÃO TRANSFERENCIAS CONCEDIDA ADICIONAL - PCA';
      case 'PCE':
        return 'PREVISÃO TRANSFERENCIAS CONCEDIDA REDUÇÃO - PCE';
      case 'PRA':
        return 'PREVISÃO TRANSFERENCIAS RECEBER ADICIONAL - PRA';
      case 'PRE':
        return 'PREVISÃO TRANSFERENCIAS RECEBER REDUÇÃO - PRE';
      case 'QCE':
        return 'QUITAÇÃO DE CONVENIO - RECEBIDOS QCE';
      case 'QCO':
        return 'QUITAÇÃO DE CONVENIO - CONCEDIDOS - QCO';
      case 'QEA':
        return 'QUITAÇÃO DE CONVENIO - AUXILIOS QEA';
      case 'QCR':
        return 'QUITAÇÃO DE CONVENIO - RECEBIMENTOS - QCR';
      case 'QDA':
        return 'QUADRO DETALHAMENTO DESPESA - ACRÉSCIMO - QDA';
      case 'QDD':
        return 'QUADRO DETALHAMENTO DESPESA - DECRÉSCIMOS - QDD';
      case 'QCC':
        return 'QUITAÇÃO DE CONVENIO - CONCESSÃO - QCC';
      case 'QCA':
        return 'QUITAÇÃO AUXÍLIOS CONCEDIDOS - QCA';
      case 'REE':
        return 'RECEITAS EXTRA ORÇAMENTÁRIAS - REE';
      case 'REA':
        return 'RECEITAS EXTRA ORÇAMENTÁRIAS ANULADAS DE RETENÇÕES - REA';
      case 'REO':
        return 'RECEITAS ORÇAMENTÁRIAS - REO';
      case 'ROC':
        return 'RECEITAS ORÇAMENTÁRIAS - RECOLHIDA POR COMPETÊNCIA - ROC';
      case 'ROR':
        return 'RECEITAS ORÇAMENTÁRIAS - REDUTORES - ROR';
      case 'RES':
        return 'RECEITAS ORÇAMENTÁRIAS - RESTITUIÇÃO - RES';
      case 'CON':
        return 'RECEBIMENTO DE CONVENIOS - CON';
      case 'ASR':
        return 'RECEBIMENTO DE AUXÍLIO SUBVENÇÃO CONTRIBUIÇÃO - ASR';
      case 'RDO':
        return 'RESERVA DE DOTAÇÃO ORÇAMENTÁRIA - RDO';
      case 'RDA':
        return 'RESERVA DE DOTAÇÃO ORÇAMENTÁRIA ANULA- RDA';
      case 'RLR':
        return 'RETENÇÕES LIQUIDAÇÃO RESTO A PAGAR - RLR';
      case 'RET':
        return 'RETENÇÕES LIQUIDAÇÃO ORÇAMENTÁRIA - RET';
      case 'RER':
        return 'RETENÇÕES EMPENHOS EXTRAS - RER';
      case 'REP':
        return 'RETENÇÕES ORÇAMENTÁRIAS CONCOMITANTE - REP';
      case 'RTD':
        return 'RECEITA TRANSFERÊNCIA DUODÉCIMO - RTD';
      case 'RDD':
        return 'RECEITA TRANSFERÊNCIA DEVOLUCAO DUODÉCIMO - RDD';
      case 'TRS':
        return 'TRANSFERENCIA DE SALDO BANCARIO - TRS';
      case 'TDP':
        return 'TRANSFERENCIA DUODÉCIMO PREFEITURA - TDP';
      case 'TDC':
        return 'TRANSFERENCIA DUODÉCIMO CÂMARA - TDC';
      case 'TRF':
        return 'TRANSFERENCIA FINANCEIRA - TRF';
      case 'TIP':
        return 'TRANSFERENCIA - INTERVENIÊNCIA PASSIVA - TIP';
      case 'TIA':
        return 'TRANSFERENCIA - INTERVENIÊNCIA ATIVA - TIA';
      case 'TPP':
        return 'TPP';
      case 'TPI':
        return 'TPI';
      case 'TRP':
        return 'TRP';
      case 'TRI':
        return 'TRI';
      case 'TRE':
        return 'TRANSFERENCIA DECENDIAL EDUCACAO - TRE';
      case 'TRR':
        return 'TRANSFERÊNCIA BANCÁRIA - RECURSOS - TRR';
      case 'VAR':
        return 'VARIAÇÃO PATRIMONIAL - VAR';
      case 'QCS':
        return 'QUITAÇÃO SUBVENÇÃO - CONCEDIDO - QCS';
      case 'APC':
        return 'CONTRATOS ASSINATURA PERMISSÃO E CONCESSÃO - APC';
      case 'CAC':
        return 'CONTRATOS DE CONSÓRCIOS - CAC';
      case 'SCA':
        return 'SUPRESSÃO DE AUXÍLIO, CONTRIBUIÇÃO E SUBVENÇÃO CONCEDIDOS - SCA';
      default:
        return idx;
    }
  }

  public obterEspecieMeta(idx: string) {
    switch (idx) {
      case 'I':
        return 'INICIAL';
      case 'A':
        return 'ALTERAÇÃO';
      case 'E':
        return 'EXCLUSÃO';
    }
    return '-';
  }

  public obterPrioridade(idx: string) {
    switch (idx) {
      case 'B':
        return 'BAIXA';
      case 'N':
        return 'NORMAL';
      case 'A':
        return 'ALTA';
      case 'U':
        return 'URGENTE';
      default:
        return '-';
    }
  }

  public listaEstados(): Array<any> {
    return [
      { codigo_ibge: 12, uf: 'AC', nome: 'Acre' },
      { codigo_ibge: 27, uf: 'AL', nome: 'Alagoas' },
      { codigo_ibge: 13, uf: 'AM', nome: 'Amazonas' },
      { codigo_ibge: 16, uf: 'AP', nome: 'Amapá' },
      { codigo_ibge: 29, uf: 'BA', nome: 'Bahia' },
      { codigo_ibge: 23, uf: 'CE', nome: 'Ceará' },
      { codigo_ibge: 53, uf: 'DF', nome: 'Distrito Federal' },
      { codigo_ibge: 32, uf: 'ES', nome: 'Espírito Santo' },
      { codigo_ibge: 52, uf: 'GO', nome: 'Goiás' },
      { codigo_ibge: 21, uf: 'MA', nome: 'Maranhão' },
      { codigo_ibge: 31, uf: 'MG', nome: 'Minas Gerais' },
      { codigo_ibge: 50, uf: 'MS', nome: 'Mato Grosso do Sul' },
      { codigo_ibge: 51, uf: 'MT', nome: 'Mato Grosso' },
      { codigo_ibge: 15, uf: 'PA', nome: 'Pará' },
      { codigo_ibge: 25, uf: 'PB', nome: 'Paraíba' },
      { codigo_ibge: 26, uf: 'PE', nome: 'Pernambuco' },
      { codigo_ibge: 22, uf: 'PI', nome: 'Piauí' },
      { codigo_ibge: 41, uf: 'PR', nome: 'Paraná' },
      { codigo_ibge: 33, uf: 'RJ', nome: 'Rio de Janeiro' },
      { codigo_ibge: 24, uf: 'RN', nome: 'Rio Grande do Norte' },
      { codigo_ibge: 11, uf: 'RO', nome: 'Rondônia' },
      { codigo_ibge: 14, uf: 'RR', nome: 'Roraima' },
      { codigo_ibge: 43, uf: 'RS', nome: 'Rio Grande do Sul' },
      { codigo_ibge: 42, uf: 'SC', nome: 'Santa Catarina' },
      { codigo_ibge: 28, uf: 'SE', nome: 'Sergipe' },
      { codigo_ibge: 35, uf: 'SP', nome: 'São Paulo' },
      { codigo_ibge: 17, uf: 'TO', nome: 'Tocantins' }
    ];
  }


  public obterTiposCreditos(idx: string) {
    switch (idx) {
      case '1':
        return 'SUPLEMENTAR';
      case '2':
        return 'ESPECIAL';
      case '3':
        return 'EXTRAORDINÁRIO';
      default:
        return '-';
    }
  }

  public obterTipoEmpenho(idx: string) {
    switch (idx) {
      case 'O':
        return 'ORDINÁRIA';
      case 'E':
        return 'ESTIMATIVA';
      case 'G':
        return 'GLOBAL';
      default:
        return idx;
    }
  }

  public obterListaTiposEmpenhos() {
    return [
      { id: 'O', nome: 'ORDINÁRIA' },
      { id: 'E', nome: 'ESTIMATIVA' },
      { id: 'G', nome: 'GLOBAL' }
    ];
  }

  public obterListaTiposCreditos() {
    return [
      { id: '1', nome: 'SUPLEMENTAR' },
      { id: '2', nome: 'ESPECIAL' },
      { id: '3', nome: 'EXTRAORDINÁRIO' }
    ];
  }

  public obterOcorrenciasCreditos(idx: string) {
    switch (idx) {
      case '1':
        return 'ANULAÇÃO PARCIAL OU TOTAL DE DOTAÇÃO';
      case '2':
        return 'EXCESSO DE ARRECADAÇÃO';
      case '3':
        return 'SUPERÁVIT FINANCEIRO';
      case '4':
        return 'OPERAÇÕES DE CRÉDITO';
      case '5':
        return 'RESERVA DE CONTINGÊNCIA';
      case '6':
        return 'PARAGRAFO 8˚ DO ARTIGO 166 DA CONSTITUIÇÃO FEDERAL';
      case '7':
        return 'REMANEJAMENTO';
      default:
        return '-';
    }
  }

  public obterListaOcorrenciasCreditos() {
    return [
      { id: '1', nome: 'ANULAÇÃO PARCIAL OU TOTAL DE DOTAÇÃO' },
      { id: '2', nome: 'EXCESSO DE ARRECADAÇÃO' },
      { id: '3', nome: 'SUPERÁVIT FINANCEIRO' },
      { id: '4', nome: 'OPERAÇÕES DE CRÉDITO' },
      { id: '5', nome: 'RESERVA DE CONTINGÊNCIA' },
      { id: '6', nome: 'PARAGRAFO 8˚ DO ARTIGO 166 DA CONSTITUIÇÃO FEDERAL' },
      { id: '7', nome: 'REMANEJAMENTO' }
    ];
  }

  public obterListaTiposFichasExtra() {
    return [
      { id: '1', nome: 'RESTOS A PAGAR' },
      { id: '2', nome: 'ANTECIPAÇÃO DE RECEITA' },
      { id: '3', nome: 'CONSIGNAÇÕES' },
      { id: '4', nome: 'RECEITA A CLASSIFICAR' },
      { id: '5', nome: 'CONVÊNIOS' },
      { id: '6', nome: 'TRANSFERÊNCIA DE RECURSOS' }
    ];
  }

  public obterListaContratacao() {
    return [
      { id: '1', nome: 'FORNECIMENTO DE MATERIAL' },
      { id: '2', nome: 'FORNECIMENTO DE SERVIÇOS' },
      { id: '3', nome: 'OBRAS' },
      { id: '4', nome: 'LOCAÇÃO' },
      { id: '5', nome: 'SERVIÇOS DE UTILIDADE PÚBLICA' },
      { id: '6', nome: 'CONTRATO DE GESTÃO' },
      { id: '7', nome: 'TERMO DE PARCERIA' },
      { id: '8', nome: 'PARCERIA PÚBLICO PRIVADA' },
      { id: '9', nome: 'OPERAÇÕES DE CRÉDITO' },
      { id: '10', nome: 'CONSÓRCIOS' },
      { id: '11', nome: 'CONCESSÃO' },
      { id: '12', nome: 'PERMISSÃO' },
      { id: '13', nome: 'FORNECIMENTO MATERIAL E SERVIÇOS' },
      { id: '14', nome: 'OUTROS' },
    ];
  }

  public obterListaTipoContrato() {
    return [
      { id: '1', nome: 'CONCESSÃO' },
      { id: '2', nome: 'PERMISSÃO' },
      { id: '3', nome: 'OUTROS' }
    ];
  }

  public obterListaFinalidade() {
    return [
      { id: 2, nome: 'AUMENTO' },
      { id: 1, nome: 'SUPRESSÃO' },
      { id: 3, nome: 'VIGÊNCIA' },
      { id: 4, nome: 'OUTROS' }
    ];
  }

  public obterFinalidade(idx: number) {
    switch (idx) {
      case 5:
        return 'ASSINATURA';
      case 2:
        return 'AUMENTO';
      case 1:
        return 'SUPRESSÃO';
      case 3:
        return 'VIGÊNCIA';
      case 6:
        return 'QUITAÇÃO';
      case 4:
        return 'OUTROS';
    }
    return;
  }

  public obterLegislacao() {
    return [
      { id: '1', nome: 'LEI FEDERAL' },
      { id: '2', nome: 'LEI ESTADUAL' },
      { id: '3', nome: 'LEI MUNICIPAL' },
      { id: '4', nome: 'DECRETO FEDERAL' },
      { id: '5', nome: 'DECRETO ESTADUAL' },
      { id: '6', nome: 'DECRETO MUNICIPAL' }
    ];
  }

  public obterListaTipoFornecedores() {
    return [
      { id: '1', nome: 'CNPJ - PESSOA JURÍDICA' },
      { id: '2', nome: 'CPF - PESSOA FÍSICA' },
      { id: '3', nome: 'IDENTIFICAÇÃO ESPECIAL' },
      { id: '4', nome: 'INSCRIÇÃO GENÉRICA-RESTOS A PAGAR-EXERCÍCIOS ANTERIORES' },
      { id: '5', nome: 'INSCRIÇÃO GENÉRICA-SENTENÇAS JUDICIAIS-NATUREZA ALIMENTAR' },
      { id: '6', nome: 'INSCRIÇÃO GENÉRICA-SENTENÇAS JUDICIAIS-OUTROS' },
      { id: '7', nome: 'INSCRIÇÃO GENÉRICA-PRECATÓRIOS-NATUREZA ALIMENTAR' },
      { id: '8', nome: 'INSCRIÇÃO GENÉRICA-PRECATÓRIOS-OUTROS' },
      { id: '9', nome: 'INSCRIÇÃO GENÉRICA-OUTROS' }
    ];
  }

  public obterListaEnquadramentoFornecedores(): { id: FavorecidoEnquadramento, nome: string }[] {
    return [
      { id: 'MEI', nome: 'MEI' },
      { id: 'ME', nome: 'ME' },
      { id: 'EPP', nome: 'EPP' },
      { id: 'EMP_NORMAL', nome: 'EMPRESA NORMAL' },
      { id: 'GRAN_PORTE', nome: 'GRANDE PORTE' },
      { id: 'OUTRA', nome: 'OUTRA' },
      { id: 'S_A', nome: 'S/A' },
      { id: 'PF', nome: 'PESSOA FÍSICA' }
    ];
  }

  public obterListaTipoContasBancarias() {
    return [
      { id: 'M', nome: 'CONTA COMUM/CONTA MOVIMENTO' },
      { id: 'V', nome: 'CONTA VINCULADA' },
      { id: 'A', nome: 'CONTA APLICAÇÃO' },
      { id: 'U', nome: 'CONTA ÚNICA' },
      { id: 'C', nome: 'CAIXA' }
    ];
  }

  public obterListaModalidadeRepasses() {
    return [
      { id: 'C', nome: 'CHAMAMENTO' },
      { id: 'D', nome: 'DISPENSA' },
      { id: 'I', nome: 'INEXIGIBILIDADE' },
    ];
  }

  public obterListaAtoUnidades() {
    return [
      { id: '1', nome: 'LEI' },
      { id: '2', nome: 'DECRETO' },
      { id: '3', nome: 'PORTARIA' },
      { id: '4', nome: 'OUTROS' }
    ];
  }
  public obterListaTiposPpa() {
    return [
      { id: 'I', nome: 'INICIAL' },
      { id: 'A', nome: 'ALTERAÇÃO' },
      { id: 'E', nome: 'EXCLUSÃO' }
    ];
  }

  public obterListaProgramas() {
    return [
      { id: 'I', nome: 'PROGRAMA FINALÍSTICO' },
      { id: 'A', nome: 'PROGRAMA DE APOIO ADMINISTRATIVO' },
      { id: 'E', nome: 'PROGRAMA DE OPERAÇÃO ESPECIAL' }
    ];
  }

  public obterListaTipoLOA() {
    return [
      { id: 'O', nome: 'ORÇAMENTÁRIA' },
      { id: 'S', nome: 'SUPLEMENTAR' },
      { id: 'E', nome: 'EXTRAORDINÁRIA' }
    ];
  }

  public obterListaJulgamentosLicitacao() {
    return [
      { id: '1', nome: 'TÉCNICA E PREÇO' },
      { id: '2', nome: 'MENOR PREÇO' },
      { id: '3', nome: 'MELHOR TÉCNICA OU CONTEÚDO ARTÍSTICO' },
      { id: '4', nome: 'MAIOR LANCE OU OFERTA' },
      { id: '5', nome: 'MAIOR DESCONTO' },
      { id: '6', nome: 'MAIOR OFERTA DE PREÇO' },
      { id: '7', nome: 'MAIOR RETORNO ECONÔMICO' },
      { id: '8', nome: 'MENOR VALOR DA TARIFA DO SERVIÇO PÚBLICO' }
    ];
  }

  public obterListaHomologacaoLicitacao() {
    return [
      { id: '1', nome: 'ADJUDICADA' },
      { id: '2', nome: 'ANULADA' },
      { id: '3', nome: 'DESERTA' },
      { id: '4', nome: 'FRACASSADA' },
      { id: '5', nome: 'HOMOLOGADA PARCIAL' },
      { id: '6', nome: 'HOMOLOGADA' },
      { id: '7', nome: 'HOMOLOGADA REGISTRO DE PREÇO' },
      { id: '8', nome: 'OUTRA' },
      { id: '9', nome: 'REVOGADA' }
    ];
  }

  public obterListaTipoOrgaos() {
    return [
      { id: 'P', nome: 'PREFEITURA MUNICIPAL' },
      { id: 'C', nome: 'CÂMARA MUNICIPAL' },
      { id: 'A', nome: 'AUTARQUIA MUNICIPAL' },
      { id: 'F', nome: 'FUNDAÇÃO MUNICIPAL' },
      { id: 'E', nome: 'EMPRESA MUNICIPAL' },
      { id: 'I', nome: 'INSTITUTO DE PREVIDÊNCIA' }
    ];
  }

  public obterListaSistemas(): { id: Sistemas, nome: string }[] {
    return [
      { id: 'almoxarifado', nome: 'ALMOXARIFADO' },
      { id: 'compras', nome: 'COMPRA' },
      { id: 'contabil', nome: 'CONTABILIDADE' },
      { id: 'controle-interno', nome: 'CONTROLE-INTERNO' },
      { id: 'diario-oficial', nome: 'DIÁRIO OFICIAL' },
      { id: 'frota', nome: 'FROTA' },
      { id: 'indicador-gestao', nome: 'INDICADOR DE GESTÃO' },
      { id: 'legislativo', nome: 'LEGISLATIVO' },
      { id: 'patrimonio', nome: 'PATRIMÔNIO' },
      { id: 'planejamento', nome: 'PLANEJAMENTO' },
      { id: 'portal-cidadao', nome: 'PORTAL DO CIDADÃO' },
      { id: 'portal-entidade', nome: 'PORTAL DA ENTIDADE' },
      { id: 'protocolo', nome: 'PROTOCOLO' },
      { id: 'recursos-humanos', nome: 'FOLHA' },
      { id: 'terceiro-setor', nome: 'TERCEIRO SETOR' },
      { id: 'tesouraria', nome: 'TESOURARIA' },
      { id: 'transparencia', nome: 'PORTAL DA TRANSPARÊNCIA' },
    ];
  }

  public obterListaTiposRepasse() {
    return [
      { id: '1', nome: 'AUXÍLIO-CONCESSÃO' },
      { id: '2', nome: 'SUBVENÇÃO-CONCESSÃO' },
      { id: '3', nome: 'CONTRIBUIÇÃO-CONCESSÃO' },
      { id: '4', nome: 'AUXÍLIO-RECEBIDO' },
      { id: '5', nome: 'SUBVENÇÃO-RECEBIDO' },
      { id: '6', nome: 'CONTRIBUIÇÃO-RECEBIDO' },
      { id: '7', nome: 'TERMO DE COLABORAÇÃO' },
      { id: '8', nome: 'TERMO DE FOMENTO' },
      { id: '9', nome: 'OUTROS' },
      { id: '10', nome: 'ACORDO DE COOPERAÇÃO' },
      { id: '11', nome: 'CONTRATO DE GESTÃO' },
      { id: '90', nome: 'TERMO DE PARCERIA' },
      { id: '91', nome: 'OUTROS CONVÊNICOS RECEBIDOS' },
      { id: '92', nome: 'OUTROS - CONVENIOS CONCEDIDOS' }
    ];
  }

  public obterListaSituacaoChamamento() {
    return [
      { nome: 'ABERTO', id: '1' },
      { nome: 'EM ANDAMENTO', id: '2' },
      { nome: 'FINALIZADO', id: '3' },
      { nome: 'CANCELADO', id: '4' }
    ];
  }

  public obterListaNatureza() {
    return [
      { id: '1', nome: '1 - RECURSOS HUMANOS (5)' },
      { id: '2', nome: '2 - RECURSOS HUMANOS (6)' },
      { id: '3', nome: '3 - MEDICAMENTOS' },
      { id: '5', nome: '5 - MATERIAL MÉDICO E HOSPITALAR (*)' },
      { id: '6', nome: '6 - GÊNEROS ALIMENTÍCIOS' },
      { id: '7', nome: '7 - OUTROS MATERIAIS DE CONSUMO' },
      { id: '8', nome: '8 - SERVIÇOS MÉDICOS' },
      { id: '9', nome: '9 - OUTROS SERVIÇOS DE TERCEIROS' },
      { id: '10', nome: '10 - LOCAÇÃO DE IMÓVEIS' },
      { id: '11', nome: '11 - LOCAÇÃO DIVERSAS' },
      { id: '12', nome: '12 - UTILIDADES PÚBLICAS (7)' },
      { id: '13', nome: '13 - COMBUSTÍVEL' },
      { id: '14', nome: '14 - BENS E MATERIAIS PERMANENTES' },
      { id: '15', nome: '15 - OBRAS' },
      { id: '16', nome: '16 - DESPESAS FINANCEIRAS E BANCÁRIAS' },
      { id: '17', nome: '17 - OUTRAS DESPESAS' },
    ];
  }

  // recursos humanos
  public obterEscolaridade() {
    return [
      { nome: '02- Alfabetização', id: '02- Alfabetização' },
      { nome: '03- Ensino Básico', id: '03- Ensino Básico' },
      { nome: '04- Ensino Básico incompleto', id: '04- Ensino Básico incompleto' },
      { nome: '05- Ensino Médio', id: '05- Ensino Médio' },
      { nome: '06- Ensino Técnico', id: '06- Ensino Técnico' },
      { nome: '07- Ensino Superior', id: '07- Ensino Superior' },
      { nome: '08- Especialização', id: '08- Especialização' },
    ];
  }

  public obterAtividade() {
    return [
      { nome: '1- Efetivo', id: '1- Efetivo' },
      { nome: '2- Efetivo em Comissão ', id: '2- Efetivo em Comissão' },
      { nome: '3- Temporário', id: '3- Temporário' },
      { nome: '4- Aposentado', id: '4- Aposentado' },
      { nome: '5- Exclusivamente em Comissão', id: '5- Exclusivamente em Comissão' },
      { nome: '7- Eletivo', id: '7- Eletivo' },
      { nome: '8- Outros', id: '8- Outros' },
      { nome: '9- Outros (não Informado)', id: '8- Outros (não Informa)' },
    ];
  }

  public obterRegimeJuridico() {
    return [
      { nome: '1- CLT', id: '1- CLT' },
      { nome: '2- Estatutário', id: '2- Estatutário' }
    ];
  }

  public obterProvimento() {
    return [
      { nome: '1- Concurso Público', id: '1- Concurso Público' },
      { nome: '2- Tempo Determinado', id: '2- Tempo Determinado' },
      { nome: '3- Livre Provimento', id: '3- Livre Provimento' },
      { nome: '4- Eleição', id: '4- Eleição' },
    ];
  }

  public obterNorma() {
    return [
      { nome: '06- Lei', id: '06- Lei' },
      { nome: '07- Lei complementar', id: '07- Lei complementar' }
    ];
  }

  public listaTipoCalculoFolha() {
    return [
      { id: 'V', nome: 'VALOR' },
      { id: 'P', nome: 'PERCENTUAL' },
      { id: 'H', nome: 'HORA' },
      { id: 'D', nome: 'DIA' }
    ];
  }

  public obterSituacoesLicitacao(): { id: SituacaoLicitacao, nome: string }[] {
    return [
      { id: 'PENDENTE', nome: 'PENDENTE' },
      { id: 'ATIVA', nome: 'ATIVA' }, // 1
      { id: 'ADJUDICADA', nome: 'ADJUDICADA' },
      { id: 'ANULADA', nome: 'ANULADA' }, // 6
      { id: 'SUSPENSA', nome: 'SUSPENSA' }, // 4
      { id: 'DESERTA', nome: 'DESERTA' }, // 2
      { id: 'FRACASSADA', nome: 'FRACASSADA' }, // 3
      { id: 'HOMOLOGADA', nome: 'HOMOLOGADA' }, // 7
      { id: 'HOMOLOGADA – PARCIAL', nome: 'HOMOLOGADA – PARCIAL' },
      { id: 'REVOGADA', nome: 'REVOGADA' }, // 5
      { id: 'OUTRA', nome: 'OUTRA' },
    ];
  }

  public obterFormatosLicitacao(): { id: FormatoLicitacao, nome: string }[] {
    return [
      { id: 'REGISTRO_PRECO', nome: 'Registro de Preço' },
      { id: 'RESERVA_VALOR', nome: 'Reserva de Valor' },
    ];
  }

  public obterCriteriosJulgamento(): { id: CriterioJulgamento, nome: string }[] {
    return [
      { id: 'MENOR_PRECO', nome: 'Menor Preço' },
      { id: 'MAIOR_PRECO', nome: 'Maior Preço' },
      { id: 'MAIOR_DESCONTO', nome: 'Maior Desconto' },
    ];
  }

  public obterCriteriosJulgamentoValor(): { id: CriterioJulgamentoValor, nome: string }[] {
    return [
      { id: 'VALOR_UNITARIO', nome: 'Valor Unitário' },
      { id: 'VALOR_TOTAL', nome: 'Valor Total' },
    ];
  }

  public obterTiposContrato(): { id: TipoContrato, nome: string }[] {
    return [
      { id: 'CONCESSAO', nome: 'Concessão' },
      { id: 'PERMISSAO', nome: 'Permissão' },
      { id: 'OUTROS', nome: 'Outros' },
    ];
  }

  public obterTiposPregao(): { id: TipoPregao, nome: string }[] {
    return [
      { id: 'PROCEDIMENTO_COMUM', nome: 'Procedimento Comum' },
      { id: 'REGISTRO_PRECO', nome: 'Registro de Preço' },
    ];
  }

  public obterCriteriosDesempate(): { id: CriterioDesempatePregao, nome: string }[] {
    return [
      { id: 'CREDENCIAMENTO', nome: 'Ordem de Credenciamento' },
      { id: 'SORTEIO', nome: 'Sorteio' },
    ];
  }

  public obterSituacoesProponente(): { id: SituacaoProponente, nome: string, style: string }[] {
    return [
      { id: 'HABILITADO', nome: 'Habilitado', style: 'success' },
      { id: 'INABILITADO', nome: 'Inabilitado', style: 'danger' },
      { id: 'DESCLASSIFICADO', nome: 'Desclassificado', style: 'danger' },
    ];
  }

  public obterSituacoesProposta(): { id: SituacaoProposta, nome: string, style: string, ordem: number }[] {
    return [
      { id: 'VENCEDOR', nome: 'Vencedor', style: 'success', ordem: 0 },
      { id: 'EMPATADO', nome: 'Empatado', style: 'danger', ordem: 0 },
      { id: 'NAO_JULGADO', nome: 'Não Julgado', style: 'secondary', ordem: 0 },

      { id: 'DESISTIDO', nome: 'Desistiu', style: 'danger', ordem: 1 },
      { id: 'INEXEQUIVEL', nome: 'Inexequível', style: 'danger', ordem: 1 },
      { id: 'EM_NEGOCIACAO', nome: 'Em Negociação', style: 'primary', ordem: 1 },
      { id: 'CLASSIFICADO', nome: 'Classificado', style: 'primary', ordem: 1 },

      { id: 'DECLINADO', nome: 'Declinou', style: 'danger', ordem: 2 },
      { id: 'NAO_CLASSIFICADO', nome: 'Não Classificado', style: 'secondary', ordem: 3 },
      { id: 'FRACASSADO', nome: 'Fracassado', style: 'danger', ordem: 4 },
      { id: 'DESCLASSIFICADO', nome: 'Desclassificado', style: 'danger', ordem: 5 },
      { id: 'INABILITADO', nome: 'Inabilitado', style: 'danger', ordem: 6 },
    ];
  }

  public obterTiposComissao(): TipoComissao[] {
    return [
      '1 - PERMANENTE', '2 - ESPECIAL', '3 - SERVIDOR DESIGNADO'
    ];
  }

  public obterAtribuicoesComissaoMembros(): ComissaoMembroAtribuicao[] {
    return [
      '1 - PRESIDENTE', '2 - MEMBRO', '3 - PREGOEIRO', '4 - EQUIPE DE APOIO', '5 - SERVIDOR DESIGNADO',
      '6 - LEILOEIRO', '7 - SECRETÁRIO', '8 - AUTORIDADE PREGÃO', '9 - RESPONSÁVEL', '10 - AUTORIDADE CONVITE'
    ];
  }

  public obterNaturezasCargoComissaoMembros(): ComissaoMembroNaturezaCargo[] {
    return [
      '1 - EFETIVO', '2 - COMISSIONADO', '3 - AGENTE POLÍTICO', '4 - EMPREGADO TEMPORÁRIO', '5 - EMPREGADO PÚBLICO', '6 - OUTROS'
    ];
  }

  public obterEspeciesAlmoxarifado(tipo?: 'E' | 'S'): { id: EspecieAlmoxarifado, nome: string }[] {
    const list: { id: EspecieAlmoxarifado, nome: string }[] = [
      { id: 'C', nome: 'COMPRA' },
      { id: 'O', nome: 'DOAÇÃO' },
      { id: 'V', nome: 'DEVOLUÇÃO' },
      { id: 'I', nome: 'INVENTÁRIO' },
      { id: 'B', nome: 'BAIXA' },
      { id: 'T', nome: 'TRANFERÊNCIA' },
      { id: 'E', nome: 'ESTORNO' },
      { id: 'F', nome: 'FRACIONAMENTO' },
      { id: 'R', nome: 'REQUISIÇÃO' }
    ];

    if (tipo === 'E') {
      list.splice(list.findIndex((itm) => { return itm.id === 'B' }), 1);
    } else if (tipo === 'S') {
      list.splice(list.findIndex((itm) => { return itm.id === 'C' }), 1);
    }
    list.splice(list.findIndex((itm) => { return itm.id === 'T' }), 1); // transferencia não é permitida como opção
    list.splice(list.findIndex((itm) => { return itm.id === 'E' }), 1); // estorno não é permitida como opção

    return list;
  }

  public tituloEspecieAlmoxarifado(especie: EspecieAlmoxarifado) {
    switch (especie) {
      case 'B':
        return 'BAIXA';
      case 'C':
        return 'COMPRA';
      case 'I':
        return 'INVENTÁRIO';
      case 'O':
        return 'DOAÇÃO';
      case 'V':
        return 'DEVOLUÇÃO';
      case 'T':
        return 'TRANFERÊNCIA';
      case 'E':
        return 'ESTORNO';
      case 'F':
        return 'FRACIONAMENTO';
    }
  }

  public corEspecieAlmoxarifado(especie: EspecieAlmoxarifado) {
    switch (especie) {
      case 'B':
        return 'secondary';
      case 'C':
        return 'primary';
      case 'I':
        return 'dark';
      case 'O':
        return 'info';
      case 'V':
        return 'warning';
      case 'T':
        return 'light';
      case 'E':
        return 'danger';
      case 'F':
        return 'warning';
    }
  }

  public tituloEspecieMovimentoEstoque(especie: string) {
    switch (especie) {
      case 'C':
        return 'COMPRA';
      case 'O':
        return 'DOAÇÃO';
      case 'V':
        return 'DEVOLUÇÃO';
      case 'I':
        return 'INENTÁRIO';
      case 'B':
        return 'BAIXA';
      case 'T':
        return 'TRANFERÊNCIA';
      case 'E':
        return 'ESTORNO';
      case 'F':
        return 'FRACIONAMENTO';
      case 'R':
        return 'REQUISIÇÃO';
    }
  };

  public listarSituacaoDocumentoTerceiroSetor() {
    return [
      { nome: 'N', id: 'NÃO ENVIADO' },
      { nome: 'E', id: 'ENVIADO E AGUARDANDO VALIDAÇÃO' },
      { nome: 'A', id: 'APROVADO' }
    ];
  }

  public obterSituacaoDocumentoTerceiroSetor(idx: string) {
    switch (idx) {
      case 'N':
        return 'NÃO ENVIADO';
      case 'E':
        return 'ENVIADO E AGUARDANDO VALIDAÇÃO';
      case 'A':
        return 'APROVADO';
      case 'R':
        return 'REJEITADO';
      case 'D':
        return 'ADEQUAÇÃO';
    }
    return '-';
  }

  public traduzirSistema(sistema: Sistemas): string {
    switch (sistema) {
      case 'controle-interno':
        return 'Controle Interno';
      case 'diario-oficial':
        return 'Diário Oficial';
      case 'indicador-gestao':
        return 'Indicador de Gestão';
      case 'portal-cidadao':
        return 'Portal do Cidadão';
      case 'portal-entidade':
        return 'Portal da Entidade';
      case 'protocolo-cidadao':
        return 'Protocolo (cidadão)';
      case 'recursos-humanos':
        return 'Recursos Humanos';
      case 'terceiro-setor':
        return 'Terceiro Setor';
      case 'transparencia':
        return 'Transparência Pública';
      case 'site':
        return 'Site Institucional';
      case 'comum':
        return 'Geral';
      default:
        return sistema.replace(/\w\S*/g, (txt: string) => {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
  }

  /// status de requisição almoxarifado
  public statusRequisicao = () => [
    StatusRequisicao.AGUARDANDO,
    StatusRequisicao.ACEITA,
    StatusRequisicao.ACEITA_PARCIALMENTO,
    StatusRequisicao.ESTORNO,
    StatusRequisicao.RECUSADO
  ];


  public tituloStatusRequisicao(status: StatusRequisicao) {
    switch (status) {
      case StatusRequisicao.AGUARDANDO:
        return 'AGUARDANDO';
      case StatusRequisicao.ACEITA:
        return 'ACEITO';
      case StatusRequisicao.ACEITA_PARCIALMENTO:
        return 'ACEITO PARCIALMENTE';
      case StatusRequisicao.ESTORNO:
        return 'ESTORNADO';
      case StatusRequisicao.RECUSADO:
        return 'RECUSADO';
    }
  };

  public corStatusRequisicao(status: StatusRequisicao) {
    switch (status) {
      case StatusRequisicao.AGUARDANDO:
        return 'warning';
      case StatusRequisicao.ACEITA:
        return 'success';
      case StatusRequisicao.ACEITA_PARCIALMENTO:
        return 'primary';
      case StatusRequisicao.ESTORNO:
        return 'secondary';
      case StatusRequisicao.RECUSADO:
        return 'danger';
    }
  }

  public iconStatusRequisicao(status: StatusRequisicao) {
    switch (status) {
      case StatusRequisicao.AGUARDANDO:
        return 'fa fa-clock-o';
      case StatusRequisicao.ACEITA:
        return 'fa fa-check';
      case StatusRequisicao.ACEITA_PARCIALMENTO:
        return 'fa fa-percent';
      case StatusRequisicao.ESTORNO:
        return 'fa fa-undo';
      case StatusRequisicao.RECUSADO:
        return 'fa fa-times';
    }
  }

  /// tipo de favorecido
  public tiposFavorecido = () => [
    TipoFavorecido.FORNECEDOR,
    TipoFavorecido.CREDOR
  ];

  public tituloTipoFavorecido(tipo: TipoFavorecido) {
    switch (tipo) {
      case TipoFavorecido.FORNECEDOR:
        return 'FORNECEDOR';
      case TipoFavorecido.CREDOR:
        return 'CREDOR';
    }
  };

  public corTipoFavorecido(tipo: TipoFavorecido) {
    switch (tipo) {
      case TipoFavorecido.FORNECEDOR:
        return 'primary';
      case TipoFavorecido.CREDOR:
        return 'danger';
    }
  }


  /// tipo de contatos favorecido
  public tiposContato = () => [
    TipoContato.TELEFONE,
    TipoContato.EMAIL,
    TipoContato.SITE,
    TipoContato.OUTROS
  ];

  public tituloTipoContato(tipo: TipoContato) {
    switch (tipo) {
      case TipoContato.TELEFONE:
        return 'TELEFONE';
      case TipoContato.EMAIL:
        return 'E-MAIL';
      case TipoContato.SITE:
        return 'SITE';
      case TipoContato.OUTROS:
        return 'OUTROS';
    }
  };

  public corTipoContato(tipo: TipoContato) {
    switch (tipo) {
      case TipoContato.TELEFONE:
        return 'success';
      case TipoContato.EMAIL:
        return 'danger';
      case TipoContato.SITE:
        return 'warning';
      case TipoContato.OUTROS:
        return 'primary';
    }
  }

  /// prioridade de rcms
  public prioridadesRCMS = (): PrioridadeRCMS[] => [
    'NORMAL', 'MEDIA', 'URGENTE'
  ];

  public tituloPrioridadeRCMS(prioridade: PrioridadeRCMS) {
    switch (prioridade) {
      case 'NORMAL':
        return 'NORMAL';
      case 'MEDIA':
        return 'MÉDIA';
      case 'URGENTE':
        return 'URGENTE';
    }
  };

  public obterListaEventos() {
    return [
      { id: 'AB1', nome: 'ABERTURA DE EXERCICIO CONTAS BANCÁRIAS - AB1' },
      { id: 'AB2', nome: 'ABERTURA DE EXERCICIO FICHAS EXTRA ORÇAMENTÁRIAS - AB2' },
      { id: 'ALG', nome: 'ALIENAÇÃO DE BENS - GANHO - ALG' },
      { id: 'ALP', nome: 'ALIENAÇÃO DE BENS - PERDA - ALP' },
      { id: 'EOA', nome: 'ANULAÇÃO DE EMPENHOS ORÇAMENTÁRIOS - EOA' },
      { id: 'LEA', nome: 'ANULAÇÃO DE LIQUIDAÇÃO EMPENHOS - LEA' },
      { id: 'PGA', nome: 'ANULAÇÃO DE PAGAMENTOS ORÇAMENTÁRIOS - PGA' },
      { id: 'ADI', nome: 'ADIANTAMENTOS CONCEDIDOS - ADI' },
      { id: 'ADD', nome: 'ADIANTAMENTOS DEVOLVIDOS - ADD' },
      { id: 'AAD', nome: 'ADIANTAMENTOS APROPRIAÇÃO DE DESPESA - AAD' },
      { id: 'ADU', nome: 'ADIANTAMENTOS UTILIZADOS - ADU' },
      { id: 'RPE', nome: 'APLICAÇÃO EDUCAÇÃO - RPE' },
      { id: 'ADA', nome: 'ARRECADAÇÃO DIVIDA ATIVA TRIBUTARIAS - CONCOMITANTE - ADA' },
      { id: 'ADN', nome: 'ARRECADAÇÃO DIVIDA ATIVA NAO TRIBUTARIAS - CONCOMITANTE - ADN' },
      { id: 'AAC', nome: 'ASSINATURA ADITAMENTO AUXÍLIO-CONCESSÃO - AAC' },
      { id: 'ARE', nome: 'ASSINATURA ADITAMENTO AUXÍLIO-RECEBIDO ESTADO - ARE' },
      { id: 'AAU', nome: 'ASSINATURA ADITAMENTO AUXÍLIO-RECEBIDO UNIÃO - AAU' },
      { id: 'CAC', nome: 'ASSINATURA ADITAMENTO CONTRIBUIÇÃO-CONCESSÃO - CAC' },
      { id: 'ASC', nome: 'ASSINATURA AUXÍLIO-CONCESSÃO - ASC' },
      { id: 'CAO', nome: 'ASSINATURA CONTRATOS OUTROS - CAO' },
      { id: 'CAA', nome: 'ASSINATURA CONTRATOS DE ALUGUEL - CAA' },
      { id: 'CAE', nome: 'ASSINATURA CONTRATOS DE EMPRESTIMOS CONCEDIDOS - CAE' },
      { id: 'CAB', nome: 'ASSINATURA CONTRATOS DE FORNECIMENTO DE BENS - CAB' },
      { id: 'CAS', nome: 'ASSINATURA CONTRATOS DE FORNECIMENTO DE SERVIÇO - CAS' },
      { id: 'CAG', nome: 'ASSINATURA CONTRATOS DE GESTÃO - CAG' },
      { id: 'CAP', nome: 'ASSINATURA CONTRATOS DE PARCELAMENTO - CAP' },
      { id: 'CAM', nome: 'ASSINATURA CONTRATOS DE SERVIÇOS E MATERIAIS - CAM' },
      { id: 'LCO', nome: 'BAIXA ACORDO DE COOPERAÇÃO - LCO' },
      { id: 'CTA', nome: 'BAIXA CONTRATOS DE ALUGUÉIS - CTA' },
      { id: 'CTE', nome: 'BAIXA CONTRATOS DE EMPRESTIMOS CONCEDIDOS - CTE' },
      { id: 'CTB', nome: 'BAIXA CONTRATOS DE FORNECIMENTO DE BENS - CTB' },
      { id: 'CTS', nome: 'BAIXA CONTRATOS DE FORNECIMENTO DE SERVIÇOS - CTS' },
      { id: 'CTP', nome: 'BAIXA CONTRATOS DE PARCELAMENTOS - CTP' },
      { id: 'LCG', nome: 'BAIXA CONTRATOS DE GESTÃO - LCG' },
      { id: 'CSS', nome: 'BAIXA CONTRATOS DE SEGUROS - CSS' },
      { id: 'CTO', nome: 'BAIXA CONTRATOS OUTROS - CTO' },
      { id: 'COV', nome: 'BAIXA CONVENIOS AUXILIOS E SUBVENCOES - COV' },
      { id: 'LTF', nome: 'BAIXA TERMO DE FOMENTO - LTF' },
      { id: 'LCT', nome: 'BAIXA TERMO DE COLABORAÇÃO - LCT' },
      { id: 'COC', nome: 'BAIXA OUTROS CONVÊNIOS CONCEDIDOS - COC' },
      { id: 'BRE', nome: 'BAIXA RETENÇÕES EXTRA ORÇAMENTÁRIAS - BRE' },
      { id: 'BCE', nome: 'BAIXA CONSIGNAÇÕES - BCE' },
      { id: 'SCA', nome: 'SUPRESSÃO DE AUXÍLIOS, CONTRIBUIÇÃO E SUBVENÇÕES CONCEDIDOS - SCA' },
      { id: 'CR1', nome: 'CRÉDITO ADICIONAL SUPLEMENTAR - CR1' },
      { id: 'CR2', nome: 'CRÉDITO ADICIONAL EXCESSO DE ARRECADAÇÃO - CR2' },
      { id: 'CR3', nome: 'CRÉDITO ADICIONAL SUPERÁVIT FINANCEIRO - CR3' },
      { id: 'CR4', nome: 'CRÉDITO ADICIONAL OPERAÇÕES DE CRÉDITO - CR4' },
      { id: 'CR5', nome: 'CRÉDITO ADICIONAL RESERVA DE CONTINGÊNCIA - CR5' },
      { id: 'CR6', nome: 'CRÉDITO ADICIONAL PARAGRAFO 8˚ DO ARTIGO 166 - CR6' },
      { id: 'CR7', nome: 'CRÉDITO ADICIONAL REMANEJAMENTO - CR7' },
      { id: 'CR8', nome: 'CRÉDITO ADICIONAL SUPLEMENTAR - CR8' },
      { id: 'CR9', nome: 'CRÉDITO ESPECIAL COM EXCESSO DE ARRECADAÇÃO - CR9' },
      { id: 'CR10', nome: 'CRÉDITO EPECIAL SUPERÁVIT FINANCEIRO - CR10' },
      { id: 'CR11', nome: 'CRÉDITO ESPECIAL OPERAÇÕES DE CRÉDITO - CR11' },
      { id: 'CR12', nome: 'CRÉDITO ESPECIAL RESERVA DE CONTINGÊNCIA - CR12' },
      { id: 'CR13', nome: 'CRÉDITO ESPECIAL PARAGRAFO 8˚ DO ARTIGO 166 - CR13' },
      { id: 'CR14', nome: 'CRÉDITO ESPECIAL REMANEJAMENTO - CR14' },
      { id: 'CR15', nome: 'CRÉDITO EXTRAORDINÁRIO SUPLEMENTAR - CR15' },
      { id: 'CR16', nome: 'CRÉDITO EXTRAORDINÁRIO COM EXCESSO DE ARRECADAÇÃO - CR16' },
      { id: 'CR17', nome: 'CRÉDITO EXTRAORDINÁRIO SUPERÁVIT FINANCEIRO - CR17' },
      { id: 'CR18', nome: 'CRÉDITO EXTRAORDINÁRIO OPERAÇÕES DE CRÉDITO - CR18' },
      { id: 'CR19', nome: 'CRÉDITO EXTRAORDINÁRIO RESERVA DE CONTINGÊNCIA - CR19' },
      { id: 'CR20', nome: 'CRÉDITO EXTRAORDINÁRIO PARAGRAFO 8˚ DO ARTIGO 166 - CR20' },
      { id: 'CR21', nome: 'CRÉDITO EXTRAORDINÁRIO REMANEJAMENTO - CR21' },
      { id: 'CR90', nome: 'CRÉDITO ADICIONAIS SUPLEMENTAR CANCELAMENTO DOTAÇÃO - CR90' },
      { id: 'CR91', nome: 'CRÉDITOS ADICIONAIS ESPECIAL CANCELAMENTO DOTAÇÃO - CR91' },
      { id: 'DDC', nome: 'DEVOLUÇÃO DEPÓSITOS E CAUÇÕES - DDC' },
      { id: 'DRP', nome: 'DEVOLUÇÃO DE RECURSOS PREFEITURA - DRP' },
      { id: 'DRC', nome: 'DEVOLUÇÃO DE RECURSOS CAMARA - DRC' },
      { id: 'ELO', nome: 'EM LIQUIDAÇÃO ORÇAMENTÁRIA - ELO' },
      { id: 'ELR', nome: 'EM LIQUIDAÇÃO RESTOS - ELR' },
      { id: 'EMP', nome: 'EMPENHOS COM PRÉ-EMPENHO - EMP' },
      { id: 'EPA', nome: 'EMPENHOS COM PRÉ-EMPENHO - ANULAÇÃO - EPA' },
      { id: 'EMO', nome: 'EMPENHOS ORÇAMENTÁRIOS - EMO' },
      { id: 'EOA', nome: 'EMPENHOS ORÇAMENTÁRIOS ANULAÇÃO - EMO' },
      { id: 'EMD', nome: 'EMPENHOS ORÇAMENTÁRIOS DISPONIBILIDADE EXERCÍCIO ANTERIOR - EMD' },
      { id: 'EMA', nome: 'EMPENHOS ORÇAMENTÁRIOS DISPON. EXERCÍCIO ANTERIOR ANULAÇÃO - EMA' },
      { id: 'ESP', nome: 'EMPENHOS REFORÇO - SEM PRÉ-EMPENHO - ESP' },
      { id: 'ECP', nome: 'EMPENHOS REFORÇO - COM PRÉ-EMPENHO - ECP' },
      { id: 'ERD', nome: 'EMPENHOS RESERVA DE DOTAÇÃO - ERD' },
      { id: 'CRA', nome: 'EXCESSO DE ARRECADAÇÃO - ANULAÇÃO - CRA' },
      { id: 'FOD', nome: 'FIXAÇÃO ORÇAMENTARIA DA DESPESA - FOD' },
      { id: 'INC', nome: 'INCORPORAÇÃO DE OBRAS E INSTALAÇÕES - INC' },
      { id: 'LEO', nome: 'LIQUIDAÇÃO ORÇAMENTÁRIAS - LEO' },
      { id: 'PLO', nome: 'LIQUIDAÇÃO DE PRÉ LIQUIDAÇÃO - PLO' },
      { id: 'PLR', nome: 'LIQUIDAÇÃO DE PRÉ LIQUIDAÇÃO DE RESTO - PLR' },
      { id: 'LRP', nome: 'LIQUIDAÇÃO DE RESTOS A PAGAR - PROCESSADOS - LRP' },
      { id: 'LRN', nome: 'LIQUIDAÇÃO DE RESTOS A PAGAR - NÃO PROCESSADOS - LRN' },
      { id: 'CAO', nome: 'CONTRATO ASSINATURA OUTRO TERCEIRO - CAO' },
      { id: 'COR', nome: 'OUTROS CONVENIOS RECEBIDOS - REMUNERAÇÃO DE APLICAÇÃO - COR' },
      { id: 'SAR', nome: 'OUTROS AUXILIOS, SUBVENÇÕES, CONTRIBUIÇÕES RECEBIDOS - REMUNERAÇÃO - SAR' },
      { id: 'OCC', nome: 'OUTROS CONVÊNIOS CONCEDIDOS ASS. C - OCC' },
      { id: 'OCR', nome: 'OUTROS CONVÊNIOS RECEBIDO ASS. C - OCR' },
      { id: 'PGO', nome: 'PAGAMENTOS ORÇAMENTÁRIOS - PGO' },
      { id: 'PGE', nome: 'PAGAMENTOS EXTRA ORÇAMENTÁRIOS - PGE' },
      { id: 'TDE', nome: 'PAGAMENTOS EXTRA ORÇAMENTÁRIOS SEM ORIGEM TRANSF DISP. EXTRA - TDE' },
      { id: 'PGR', nome: 'PAGAMENTOS DE RESTOS A PAGAR - PGR' },
      { id: 'PRN', nome: 'PAGAMENTO DE RESTOS A PAGAR NÃO PROCESSADOS - CONCOMITANTE - PRN' },
      { id: 'PRP', nome: 'PAGAMENTO DE RESTOS A PAGAR PROCESSADOS  - CONCOMITANTE - PRP' },
      { id: 'PDL', nome: 'PARCELAMENTO DE DIVIDA - BAIXA - PDL' },
      { id: 'PAD', nome: 'PREVISÃO ADICIONAL DA DESPESA - PAD' },
      { id: 'PED', nome: 'PREVISÃO REDUTORA DA DESPESA - PED' },
      { id: 'PAR', nome: 'PREVISÃO ADICIONAL DA RECEITA - PAR' },
      { id: 'PIR', nome: 'PREVISÃO INICIAL DA RECEITA - PIR' },
      { id: 'PRR', nome: 'PREVISÃO INICIAL REDUTORES DA RECEITA - PRR' },
      { id: 'RRP', nome: 'PREVISÃO INICIAL RENUNCIA DE RECEITA - RRP' },
      { id: 'PRS', nome: 'PREVISÃO INICIAL RESTITUIÇÃO DE RECEITA - PRS' },
      { id: 'PTC', nome: 'PREVISÃO TRANSFERENCIAS A CONCEDER - PTC' },
      { id: 'PTR', nome: 'PREVISÃO TRANSFERENCIAS A RECEBER - PTR' },
      { id: 'PCA', nome: 'PREVISÃO TRANSFERENCIAS CONCEDIDA ADICIONAL - PCA' },
      { id: 'PCE', nome: 'PREVISÃO TRANSFERENCIAS CONCEDIDA REDUÇÃO - PCE' },
      { id: 'PRA', nome: 'PREVISÃO TRANSFERENCIAS RECEBER ADICIONAL - PRA' },
      { id: 'PRE', nome: 'PREVISÃO TRANSFERENCIAS RECEBER REDUÇÃO - PRE' },
      { id: 'QCA', nome: 'QUITAÇÃO AUXÍLIOS CONCEDIDOS - QCA' },
      { id: 'QCC', nome: 'QUITAÇÃO DE CONVENIO - CONCESSÃO - QCC' },
      { id: 'QCE', nome: 'QUITAÇÃO DE CONVENIO - RECEBIDOS QCE' },
      { id: 'QCO', nome: 'QUITAÇÃO DE CONVENIO - CONCEDIDOS - QCO' },
      { id: 'QEA', nome: 'QUITAÇÃO DE CONVENIO - AUXILIOS QEA' },
      { id: 'QCR', nome: 'QUITAÇÃO DE CONVENIO - RECEBIMENTOS - QCR' },
      { id: 'QDA', nome: 'QUADRO DETALHAMENTO DESPESA - ACRÉSCIMO - QDA' },
      { id: 'QDD', nome: 'QUADRO DETALHAMENTO DESPESA - DECRÉSCIMOS - QDD' },
      { id: 'REE', nome: 'RECEITAS EXTRA ORÇAMENTÁRIAS - REE' },
      { id: 'REA', nome: 'RECEITAS EXTRA ORÇAMENTÁRIAS ANULADAS DE RETENÇÕES - REA' },
      { id: 'REO', nome: 'RECEITAS ORÇAMENTÁRIAS - REO' },
      { id: 'ROC', nome: 'RECEITAS ORÇAMENTÁRIAS - RECOLHIDA POR COMPETÊNCIA - ROC' },
      { id: 'ROR', nome: 'RECEITAS ORÇAMENTÁRIAS - REDUTORES - ROR' },
      { id: 'RES', nome: 'RECEITAS ORÇAMENTÁRIAS - RESTITUIÇÃO - RES' },
      { id: 'CON', nome: 'RECEBIMENTO DE CONVENIOS - CON' },
      { id: 'ASR', nome: 'RECEBIMENTO DE AUXÍLIO SUBVENÇÃO CONTRIBUIÇÃO - ASR' },
      { id: 'RDO', nome: 'RESERVA DE DOTAÇÃO ORÇAMENTÁRIA - RDO' },
      { id: 'RDA', nome: 'RESERVA DE DOTAÇÃO ORÇAMENTÁRIA ANULA- RDA' },
      { id: 'RET', nome: 'RETENÇÕES LIQUIDAÇÃO ORÇAMENTÁRIA - RET' },
      { id: 'RLR', nome: 'RETENÇÕES LIQUIDAÇÃO RESTO A PAGAR -RLR' },
      { id: 'RER', nome: 'RETENÇÕES EMPENHOS EXTRAS - RER' },
      { id: 'COS', nome: 'RETENÇÕES EXTRA ORÇAMENTÁRIA - CONCOMITANTE - COS' },
      { id: 'REP', nome: 'RETENÇÕES ORÇAMENTÁRIAS CONCOMITANTE - REP' },
      { id: 'RTD', nome: 'RECEITA TRANSFERÊNCIA DUODÉCIMO - RTD' },
      { id: 'RDD', nome: 'RECEITA TRANSFERÊNCIA DEVOLUCAO DUODÉCIMO - RDD' },
      { id: 'SCA', nome: 'SUPRESSÃO DE AUXÍLIO, CONTRIBUIÇÃO E SUBVENÇÃO CONCEDIDOS - SCA' },
      { id: 'TRS', nome: 'TRANSFERENCIA DE SALDO BANCARIO - TRS' },
      { id: 'TDP', nome: 'TRANSFERENCIA DUODÉCIMO PREFEITURA - TDP' },
      { id: 'TDC', nome: 'TRANSFERENCIA DUODÉCIMO CÂMARA - TDC' },
      { id: 'TRF', nome: 'TRANSFERENCIA FINANCEIRA - TRF' },
      { id: 'TIP', nome: 'TRANSFERENCIA - INTERVENIÊNCIA PASSIVA - TIP' },
      { id: 'TIA', nome: 'TRANSFERENCIA - INTERVENIÊNCIA ATIVA - TIA' },
      { id: 'TPP', nome: 'TPP' },
      { id: 'TPI', nome: 'TPI' },
      { id: 'TRP', nome: 'TRP' },
      { id: 'TRI', nome: 'TRI' },
      { id: 'TRE', nome: 'TRANSFERENCIA DECENDIAL EDUCACAO - TRE' },
      { id: 'TRR', nome: 'TRANSFERÊNCIA BANCÁRIA - RECURSOS - TRR' },
      { id: 'VAR', nome: 'VARIAÇÃO PATRIMONIAL - VAR' },
      { id: 'QCS', nome: 'QUITAÇÃO SUBVENÇÃO - CONCEDIDO - QCS' },
      { id: 'APC', nome: 'CONTRATOS ASSINATURA PERMISSÃO E CONCESSÃO - APC' }
    ];
  }

  public obterTiposObjetoLicitacao(): { id: TipoObjetoLicitacao, nome: string }[] {
    return [
      { id: 'COMPRA_SERVICO', nome: 'Compras e Serviço' },
      { id: 'COMPRA_SERVICO_TI', nome: 'Compras e Serviços de TI' },
      { id: 'ENGENHARIA', nome: 'Obras e Serviços de Engenharia' },
    ]
  }

  public obterObjetoLicitacao(tipo: TipoObjetoLicitacao): { id: number, nome: string }[] {
    if (!tipo) return [];
    switch (tipo) {
      case 'COMPRA_SERVICO':
        return [
          { id: 1, nome: 'Equipamentos e material permanente' },
          { id: 2, nome: 'Material de expediente' },
          { id: 6, nome: 'Medicamentos' },
          { id: 16, nome: 'Outros materiais de consumo' },
          { id: 19, nome: 'Coleta de lixo' },
          { id: 23, nome: 'Limpeza Urbana/Varrição' },
          { id: 24, nome: 'Material Escolar' },
          { id: 25, nome: 'Transporte Escolar' },
          { id: 26, nome: 'Uniforme Escolar' },
          { id: 27, nome: 'Publicidade/Propaganda' },
          { id: 3, nome: 'Gêneros alimentícios' },
          { id: 4, nome: 'Combustíveis e lubrificantes' },
          { id: 5, nome: 'Material hospitalar, ambulatorial ou odontológico' },
          { id: 7, nome: 'Passagens aéreas e outras despesas de locomoção' },
          { id: 8, nome: 'Serviços de consultoria' },
          { id: 10, nome: 'Locação de imóveis' },
          { id: 11, nome: 'Locação de mão de obra' },
          { id: 12, nome: 'Operações de crédito (exceto ARO)' },
          { id: 13, nome: 'Concessão de serviço público' },
          { id: 14, nome: 'Permissão' },
          { id: 17, nome: 'Outras prestações de serviço' },
        ];
      case 'COMPRA_SERVICO_TI':
        return [
          { id: 22, nome: 'Compras de TI' },
          { id: 18, nome: 'Serviços de TI' },
        ];
      case 'ENGENHARIA':
        return [
          { id: 9, nome: 'Obras e serviços de engenharia' },
          { id: 20, nome: 'Implantação de aterro sanitário' },
        ];
    }
  }

  public obterNaturezaLicitacao(): { id: number, nome: string }[] {
    return [
      { id: 6, nome: 'Concessão Pública' },
      { id: 3, nome: 'Credenciamento' },
      { id: 1, nome: 'Normal' },
      { id: 7, nome: 'Permissão Pública' },
      { id: 4, nome: 'PPP Administrativa' },
      { id: 5, nome: 'PPP Patrocinada' },
      { id: 2, nome: 'Registro de Preços' },
    ]
  }

  public obterTipoLicitacao(): { id: number, nome: string }[] {
    return [
      { id: 4, nome: 'Maior Lance ou Oferta' },
      { id: 5, nome: 'Maior Desconto' },
      { id: 12, nome: 'Melhor destinação de bens alienados (Lei nº 13.303/2016)' },
      { id: 1, nome: 'Menor preço' },
      { id: 2, nome: 'Técnica e preço' },
      { id: 3, nome: 'Melhor técnica ou Conteúdo Artístico' },
      { id: 6, nome: 'Maior Oferta de Preço' },
      { id: 7, nome: 'Maior Retorno Econômico' },
      { id: 8, nome: 'Menor valor da tarifa do serviço público' },
      { id: 9, nome: 'Menor valor da tarifa + melhor técnica' },
      { id: 10, nome: 'Menor valor da contraprestação' },
      { id: 11, nome: 'Menor valor da contraprestação + melhor técnica' },
    ]
  }

  public obterLei1232006Licitacao(): { id: number, nome: string }[] {
    return [
      { id: 3, nome: 'Tratamento Diferenciado/Simplificado' },
      { id: 1, nome: 'Não se aplica' },
      { id: 2, nome: 'Licitação Exclusiva' },
    ]
  }

  public obterCloudArmazenamento() {
    return [{ id: 'FIREBASE', nome: 'Firebase' }]
  }

  public obterSituacaoPatrimonio(inventario?: boolean): { id: SituacaoPatrimonio, nome: string, estilo: string }[] {
    if (inventario) {
      return [
        { id: 'ATIVO', nome: 'Em uso', estilo: 'success' },
        { id: 'CESSAO', nome: 'Em cessão de uso', estilo: 'secondary' },
        { id: 'MANUTENCAO', nome: 'Em manutenção', estilo: 'secondary' },
        { id: 'NAO_LOCALIZADO', nome: 'Não localizado', estilo: 'warning' },
      ]
    } else {
      return [
        { id: 'ATIVO', nome: 'Em uso', estilo: 'success' },
        { id: 'BAIXADO', nome: 'Baixado', estilo: 'danger' },
        { id: 'CESSAO', nome: 'Em cessão de uso', estilo: 'secondary' },
        { id: 'EXCLUIDO', nome: 'Excluído', estilo: 'danger' },
        { id: 'MANUTENCAO', nome: 'Em manutenção', estilo: 'secondary' },
        { id: 'NAO_LOCALIZADO', nome: 'Não localizado', estilo: 'warning' },
      ]
    }
  }

  public obterConservacaoPatrimonio(): { id: ConservacaoPatrimonio, nome: string, estilo: string }[] {
    return [
      { id: 'EXCELENTE', nome: 'Excelente', estilo: 'success' },
      { id: 'BOM', nome: 'Bom', estilo: 'primary' },
      { id: 'REGULAR', nome: 'Regular', estilo: 'info' },
      { id: 'RUIM', nome: 'Ruim', estilo: 'warning' },
      { id: 'INSERVIVEL', nome: 'Inservível', estilo: 'danger' },
    ]
  }
}

